import React from "react";

const MeetingJoinPage = () => {
  const getUrl = () => {
    document.getElementById("zmmtg-root")?.remove();
    const url = window.localStorage.getItem("meetingUrl");
    if (url) {
      window.location.href = url;
      window.location.reload();
    }
  };

  React.useEffect(() => {
    getUrl();
    return () => {};
  }, []);

  return <div></div>;
};

export default MeetingJoinPage;
